







































































import { AxiosPromise } from 'axios';
import Component, { mixins } from 'vue-class-component';
import UseBackend from '@/core/mixins/use-backend';
import { Prop } from 'vue-property-decorator';
import { HUNTING_LICENSE_ORDERS } from '@/common/api';

import isObject from 'lodash/isObject';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import camelCase from 'lodash/camelCase';
import EntityLink from '@/shared_components/EntityLink.vue';
import {
  ChargeType,
  gisGmpStatuses,
} from '@/modules/HuntingLicenses/LicenseOrder/licences.constants';
import ChargeInfo from '@/modules/HuntingLicenses/LicenseOrder/ChargeInfo.vue';
import SubscriptionPayments from '@/modules/HuntingLicenses/LicenseOrder/SubscriptionPayments.vue';
import { capitalize } from '@/common/helpers';
import HuntingLicenseOrderFull = Orders.HuntingLicenseOrderFull;
import GisGmpChargeFull = Orders.GisGmpChargeFull;

interface SendCharge {
  type: ChargeType;
  amount: number;
}

function mapObject(data: Orders.GisGmpChargeFull['chargeData']) {
  const mappedKeys = mapKeys(data, (value, key) => {
    const modified = camelCase(key);
    if (isObject(value)) {
      return capitalize(modified);
    }
    return modified;
  });
  const mappedValues = mapValues(mappedKeys, (value) => {
    if (isObject(value) && !Array.isArray(value)) {
      return mapObject(value);
    }

    return value;
  });
  return mappedValues;
}

@Component({
  name: 'HuntingLicenseOrderCharges',
  components: { ChargeInfo, EntityLink, SubscriptionPayments },
})
export default class HuntingLicenseOrderCharges extends mixins(UseBackend) {
  @Prop({ type: Object, required: true })
  order!: HuntingLicenseOrderFull;

  dialogState: boolean = false;

  chargeLoading: boolean = false;

  charge: SendCharge = {
    type: ChargeType.duty,
    amount: 650,
  };

  gisGmpCharges = [
    {
      value: ChargeType.duty,
      label: 'Госпошлина',
    },
  ];

  gisGmpStatuses = gisGmpStatuses;

  columns: Array<QuasarTableColumn> = [
    {
      name: 'type',
      label: 'Назначение платежа',
      field: 'purpose',
      align: 'left',
      style: 'max-width: 400px;white-space: normal;',
    },
    {
      name: 'status',
      label: 'Статус',
      field: (val) => this.gisGmpStatuses[val.status],
    },
    {
      name: 'billId',
      label: 'УИН',
      field: 'billId',
    },
    {
      name: 'createdAt',
      label: 'Дата выставления',
      field: (val) => new Date(val.createdAt).toLocaleString(),
    },
    {
      name: 'amount',
      label: 'Сумма (руб.)',
      field: (val) => val.amount / 100,
    },
    {
      name: 'cancel',
      label: '',
    },
  ];

  private currentCharge: GisGmpChargeFull | null = null;

  async mounted() {
    // const { data } = await this.makeRequest(() => this.$http(GISGMP_SETTINGS.LIST));
    // this.$set(this.$data, 'settings', data);
  }

  async showQuittance(chargeId: number) {
    this.dialogState = true;
    const data = await this.getCharge(chargeId);
    this.currentCharge = this.modifyCharge(data);
  }

  private modifyCharge(data: Orders.GisGmpChargeFull) {
    if (typeof data.chargeData.bill_date === 'undefined') {
      return data;
    }
    // eslint-disable-next-line no-param-reassign
    data.chargeData = mapObject(data.chargeData);
    console.debug(data);
    return data;
  }

  private async getCharge(chargeId: number) {
    const endpoint = HUNTING_LICENSE_ORDERS.GET_CHARGE(this.order.id, chargeId);
    const { data } = await this.dialogMakeRequest(
      () => this.$http(endpoint) as AxiosPromise<GisGmpChargeFull>
    );
    return data;
  }

  async refreshCharge({ id }: Orders.GisGmpChargeFull) {
    const charge = await this.getCharge(id);
    const index = this.order.charges.findIndex((c) => c.id === charge.id);
    if (index !== -1) {
      this.order.charges.splice(index, 1, charge);
    }
  }

  async send() {
    const { data } = await this.makeRequest(() =>
      this.$http({ ...HUNTING_LICENSE_ORDERS.SEND_CHARGE(this.order.id), data: this.charge })
    );
    this.order.charges.unshift(data);
  }

  async cancel({ charge: { id }, done }) {
    const { data } = await this.dialogMakeRequest(() =>
      this.$http(HUNTING_LICENSE_ORDERS.CANCEL_CHARGE(this.order.id, id))
    );
    this.currentCharge = this.modifyCharge(data);
    const index = this.order.charges.findIndex((c) => c.id === id);
    if (index !== -1) {
      this.order.charges.splice(index, 1, data);
    }
    done();
  }

  async check({ charge: { id }, done }) {
    const { data } = await this.dialogMakeRequest(() =>
      this.$http(HUNTING_LICENSE_ORDERS.CHECK_CHARGE(this.order.id, id))
    );
    this.currentCharge = this.modifyCharge(data);
    const index = this.order.charges.findIndex((c) => c.id === id);
    if (index !== -1) {
      this.order.charges.splice(index, 1, data);
    }
    done();
  }

  hideQuittance() {
    this.dialogState = false;
    this.currentCharge = null;
  }

  dialogMakeRequest<T>(fn: () => Promise<T>) {
    return this.makeRequest(fn, {
      startLoading: () => {
        this.chargeLoading = true;
      },
      finishLoading: () => {
        this.chargeLoading = false;
      },
    });
  }
}
